import { z } from 'zod';

export const ThreadTargetTypeSchema = z.enum(['order']);
export type ThreadTargetType = z.infer<typeof ThreadTargetTypeSchema>;

export interface ThreadTarget {
    targetType: ThreadTargetType;
    targetId: number;
    // Free-form label rendered in the modal title. Caller-provided so the
    // modal doesn't have to fetch the target row just for a heading.
    label?: string;
}

export const ThreadParamsSchema = z
    .object({
        resolvesIssueId: z.number().nullish(),
    })
    .passthrough();

export type ThreadParams = z.infer<typeof ThreadParamsSchema>;

export const ThreadAuthorSchema = z.object({
    id: z.number(),
    name: z.string().nullish(),
    email: z.string().nullish(),
});

export const ThreadSchema = z.object({
    id: z.number(),
    targetType: z.string(),
    targetId: z.number(),
    parentId: z.number().nullish(),
    userId: z.number(),
    message: z.string(),
    params: ThreadParamsSchema.nullish(),
    createdAt: z.string().nullish(),
    updatedAt: z.string().nullish(),
    author: ThreadAuthorSchema.nullish(),
});

export type Thread = z.infer<typeof ThreadSchema>;

export const ThreadListResponseSchema = z.object({
    success: z.boolean(),
    data: z.array(ThreadSchema),
    count: z.number(),
});

export const ThreadResponseSchema = z.object({
    success: z.boolean(),
    data: ThreadSchema,
});

export const ReplyFormSchema = z.object({
    message: z.string().trim().min(1, 'Mesajul este obligatoriu').max(5000, 'Maxim 5000 de caractere'),
});

export type ReplyFormValues = z.infer<typeof ReplyFormSchema>;

export const OrderWithIssuesRowSchema = z.object({
    id: z.number(),
    orderNumber: z.string().nullish(),
    status: z.string().nullish(),
    paymentStatus: z.string().nullish(),
    grandTotal: z.number().nullish(),
    delivery: z.string().nullish(),
    deliveryName: z.string().nullish(),
    createdAt: z.string().nullish(),
    isPreorder: z.number().nullish(),
    isBackorder: z.number().nullish(),
    isSingles: z.number().nullish(),
    issues: z.number(),
    oldestIssueAt: z.string().nullish(),
    locationId: z.number().nullish(),
    companyName: z.string().nullish(),
    user: z
        .object({ id: z.number(), name: z.string().nullish(), email: z.string().nullish() })
        .nullable(),
});

export type OrderWithIssuesRow = z.infer<typeof OrderWithIssuesRowSchema>;

export const OrdersWithIssuesResponseSchema = z.object({
    success: z.boolean(),
    orders: z.array(OrderWithIssuesRowSchema),
    pagination: z.object({
        page: z.number(),
        limit: z.number(),
        totalCount: z.number(),
        totalPages: z.number(),
    }),
});

export type OrdersWithIssuesResponse = z.infer<typeof OrdersWithIssuesResponseSchema>;
